import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../../../../styles/globals';

export const TitleElem = styled(LabelRegularBoldM)`
  ${({ theme }) => `
    margin: 0;
    color: ${theme.colors.neutral.primary[80]};
    text-transform: uppercase;
    letter-spacing: 0.08em;
  `};
`;
